import { DonutChart } from '@mantine/charts';
import Colors from '../../constants/Colors';

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const PieChart = ({ data, currency, size = 160 }) => {
  if (!data || (Array.isArray(data) && data.length === 0)) return null;

  // Transform data for Mantine DonutChart
  // Nivo format: [{ label: 'A', value: 10, color?: 'red' }, ...]
  // Mantine format: [{ name: 'A', value: 10, color: 'red' }, ...]
  const transformedData = data.map((item, i) => ({
    name: capitalizeFirstLetter(item.label),
    value: item.value,
    color: item.color || Colors[i % Colors.length],
  }));

  // Custom value formatter for currency
  const valueFormatter = currency
    ? (value) => value?.toLocaleString(navigator.language, { style: 'currency', currency })
    : (value) => value?.toLocaleString(navigator.language);

  return (
    <div
      style={{
        minHeight: size,
        minWidth: size,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        zIndex: 10,
      }}
    >
      <DonutChart
        h={size}
        w={size}
        size={size}
        data={transformedData}
        thickness={size > 140 ? 20 : 18}
        paddingAngle={6}
        withLabels={false}
        withTooltip
        tooltipDataSource="segment"
        valueFormatter={valueFormatter}
      />
    </div>
  );
};

export default PieChart;
